import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import DescricaoExpedicao from '../campos/descricaoExpedicao';
import FotosVideos from '../campos/fotosVideos';
import PerguntaExploratoria from '../campos/perguntaExploratoria';
import TerritorioInvestigado from '../campos/territorioInvestigado';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.expedicao;
export default function ExpedicaoInvestigativa() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({
      type: 'setEtapa',
      payload: etapa,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <TerritorioInvestigado />
        <PerguntaExploratoria />
        <DescricaoExpedicao />
        <FotosVideos etapa={etapa} />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
